import React, { Component } from 'react';
import { Table } from 'antd';

class OrderDetailView extends Component {
    render() {
        const order = this.props.order;
        const columns = [{
            title: 'Cant',
            dataIndex: 'cant',
            key: 'cant',
        }, {
            title: 'Número de Parte',
            dataIndex: 'part_num',
            key: 'part_num',
        }, {
            title: 'Descripción',
            dataIndex: 'description_en',
            key: 'description_en',
        }, {
            title: 'Peso Total',
            dataIndex: 'kg_per_pc',
            key: 'kg_per_pc',
            render: (txt, row) => (row.cant * txt).toFixed(4)
        }, {
            title: 'Precio Total',
            dataIndex: 'price',
            key: 'price',
            render: (txt, row) => '€ ' + (row.cant * txt)
        }];
        return (
            <div>
                <b>Cliente: </b> {order.client} <br/>
                <b>Fecha: </b> {(new Date(order.date)).toString()} <br/>
                <b>Total: </b> € {order.total} <br/>
                <b>Peso: </b> {(order.weight != null)?order.weight.toFixed(4):0} Kgs <br/>
                <hr/>
                <Table 
                    dataSource={order.products}
                    columns={columns}
                />
            </div>
        );
    }
}

export default OrderDetailView;



// WEBPACK FOOTER //
// ./src/components/views/OrderDetailView.jsx